import { render, staticRenderFns } from "./VaPaletteCustom.demo.vue?vue&type=template&id=a063be02&"
import script from "./VaPaletteCustom.demo.vue?vue&type=script&lang=js&"
export * from "./VaPaletteCustom.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports